<template>
  <transition name="fade">
    <div v-if="show" role="dialog" aria-modal="true" class="image-confirm-modal" @click.self="$emit('close')">
      <div class="image-confirm-modal__dialog">
        <div class="image-confirm-modal__modal-content">
          <div class="image-confirm-modal__modal-body">
            <p class="title">{{ trans.get('pages:chat.send_image_modal.title') }}</p>
            <p class="subtitle">{{ trans.get('pages:chat.send_image_modal.subtitle', { price: priceByMessage }) }}</p>

            <div class="image-confirm-modal__buttons">
              <button class="button-cancel" @click="$emit('close')">{{ trans.get('pages:chat.send_image_modal.buttons.cancel') }}</button>
              <button class="button-accept" @click="$emit('confirm')">{{ trans.get('pages:chat.send_image_modal.buttons.confirm') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ConfirmImageSendModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    priceByMessage() {
      return this.globals.settings_payment_chat_message;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/common/base/_base-mixin.scss';

.image-confirm-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;

  &__dialog {
    max-width: 500px;
    width: 100%;
  }

  &__modal-content {
    margin: 0 auto;
    background: #fff;
    position: relative;
    max-width: 90%;
    box-shadow: 4px 0px 15px -4px #c7c7c7f5;
    -moz-box-shadow: 4px 0px 15px -4px #c7c7c7f5;
    -webkit-box-shadow: 4px 0px 15px -4px #c7c7c7f5;
    padding: 1.5rem;
    border-radius: 1.5rem;
    border: none;
  }

  &__modal-body {
    text-align: center;
    padding: 1rem 1rem 0.3rem 1rem;

    @include phone {
      padding: 0.3rem 0 0 0;
    }
  }

  .title,
  .subtitle,
  .buttons-container {
    font-weight: 400;
    line-height: 1;
  }

  .title {
    color: #b74a7a;
    font-size: 18px;
    margin-bottom: 15px;

    @include phone {
      font-size: 16px;
    }
  }

  .subtitle {
    color: #a1a1a1;
    font-size: 14px;
    margin-bottom: 30px;

    @include phone {
      margin-bottom: 25px;
    }
  }

  &__buttons {
    display: flex;
    justify-content: center;
    gap: 10px;

    .button-accept,
    .button-cancel {
      font-size: 18px;
      border-radius: 17px;
      transition: 0.3s;
      line-height: 1;
      padding: 12px;

      &:hover {
        opacity: 0.85;
      }

      @include phone {
        font-size: 15px;
      }
    }

    .button-cancel {
      border: 2px solid #b74a7a;
      color: #a63d6c;
      background-color: transparent;
      flex: 1;
    }

    .button-accept {
      background-color: #b74a7a;
      color: #fff;
      border: none;
      flex: 3;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s linear;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
